import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  isCreationInProgress: false,
  isUpdateInProgress: false,
  isAlertMachinesLoading: false,
  alertMachines: null,
  isDeletionInProgress: [],
  i: -1,
  j: -1
};

export default createReducer(initialState, {
  [c.GET_ASSIGNED_ALERTS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_ASSIGNED_ALERTS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload.map((alertPersona) => ({
      ...alertPersona
    })),
    isLoading: false,
    isDeletionInProgress: new Array(payload.length).fill(false)
  }),
  [c.GET_ASSIGNED_ALERTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.CREATE_ALERT_PERSONA_REQUEST]: (state) => {
    return {
      ...state,
      error: null,
      isCreationInProgress: true
    };
  },
  [c.CREATE_ALERT_PERSONA_SUCCESS]: (state, { payload }) => {
    const newState = { ...state };
    const data = [...newState.data];
    data.push(payload);
    return {
      ...state,
      isCreationInProgress: false,
      isDeletionInProgress: new Array(state.data.length + 1).fill(false),
      data
    };
  },
  [c.CREATE_ALERT_PERSONA_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isCreationInProgress: false
  }),
  [c.UPDATE_ALERT_PERSONA_REQUEST]: (state) => ({
    ...state,
    error: null,
    isUpdateInProgress: true
  }),
  [c.UPDATE_ALERT_PERSONA_SUCCESS]: (state) => ({
    ...state,
    isUpdateInProgress: false
  }),
  [c.UPDATE_ALERT_PERSONA_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isUpdateInProgress: false
  }),
  [c.DELETE_ALERT_PERSONA_REQUEST]: (state, { payload }) => {
    const newState = { ...state, error: null };
    newState.isDeletionInProgress[payload.index] = true;
    return newState;
  },
  [c.DELETE_ALERT_PERSONA_SUCCESS]: (state, { payload }) => {
    const data = [...state.data];
    return {
      ...state,
      error: null,
      data: data.filter((e) => e.id !== payload.id),
      isDeletionInProgress: new Array(state.data.length - 1).fill(false)
    };
  },
  [c.DELETE_ALERT_PERSONA_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isDeletionInProgress: new Array(state.data.length).fill(false)
  }),
  [c.UPDATE_ALERT_PERSONA_RECIPIENT_REQUEST]: (state, { payload }) => {
    const modifiedState = { ...state };
    const index = modifiedState.data.findIndex(
      (e) => e.id === payload.personaId
    );
    if (index !== -1) {
      if (
        modifiedState.data[index].email &&
        modifiedState.data[index].email.id === payload.ids[0]
      ) {
        modifiedState.data[index].email.isActive = payload.isActive;
      }
      if (
        modifiedState.data[index].sms &&
        modifiedState.data[index].sms.id === payload.ids[0]
      ) {
        modifiedState.data[index].sms.isActive = payload.isActive;
      }

      if (
        modifiedState.data[index].whatsapp &&
        modifiedState.data[index].whatsapp.id === payload.ids[0]
      ) {
        modifiedState.data[index].whatsapp.isActive = payload.isActive;
      }
    }
    return {
      ...modifiedState,
      error: null
    };
  },
  [c.UPDATE_ALERT_PERSONA_RECIPIENT_SUCCESS]: (state) => ({
    ...state
  }),
  [c.UPDATE_ALERT_PERSONA_RECIPIENT_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.GET_ALERT_MACHINES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isAlertMachinesLoading: true
  }),
  [c.GET_ALERT_MACHINES_SUCCESS]: (state, { payload }) => ({
    ...state,
    alertMachines: payload,
    isAlertMachinesLoading: false
  }),
  [c.GET_ALERT_MACHINES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isAlertMachinesLoading: false
  }),
  [c.UPDATE_ALERT_MACHINE_REQUEST]: (state) => ({
    ...state
  }),
  [c.UPDATE_ALERT_MACHINE_SUCCESS]: (state) => ({
    ...state
  }),
  [c.UPDATE_ALERT_MACHINE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.UPDATE_ACTIVE_DROPDOWN]: (state, { payload }) => ({
    ...state,
    i: payload.i,
    j: payload.j
  })
});
